import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NotAccessibleIcon(props: IconProps) {
    return <Icon {...props} iconKey={"not_accessible"}/>
}
